import React, { useState, useEffect, useRef, Suspense, lazy } from 'react';
import { Route, Routes, useLocation, Navigate } from 'react-router-dom';
import TagManager from 'react-gtm-module';

import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import { setCookie } from './utils/cookies';
import { createUser } from './api/api';


// Articles
import ArticlePaycheckToPaycheck from "./pages/articles/ArticleMiddleAgedDadDiscovers";
import ArticleITriedTheCareerFreedomPlan from './pages/articles/ArticleITriedTheCareerFreedomPlan';
import ArticleAIRanMyMarketing from './pages/articles/ArticleAIRanMyMarketing';
import ArticleMorningRoutine from './pages/articles/ArticleMorningRoutine';

const mainFunnelName = "go";
const mainFunnelVersion = "1";

// Global pages
const ContactPage = lazy(() => import('./pages/ContactPage'));
const Lander = lazy(() => import('./pages/Lander/Lander'));

// Old funnels (go, stt, claude, life-reset…) are retired: send them home, keeping utm/fbclid
function RedirectHome() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: '/', search }} replace />;
}

// The current terms and privacy policy live with the planner app; old links keep working
function ExternalRedirect({ to }) {
  useEffect(() => { window.location.replace(to); }, [to]);
  return null;
}

function App() {
  const location = useLocation();
  const [selectedGender, setSelectedGender] = useState(null);

  const params = new URLSearchParams(window.location.search);

  const source = params.get("utm_source")
  if (source) {
    setCookie("utm_source", source);
  }

  const medium = params.get("utm_medium")
  if (medium) {
    setCookie("utm_medium", medium);
  }

  const campaign = params.get("utm_campaign")
  if (campaign) {
    setCookie("utm_campaign", campaign);
  }

  const content = params.get("utm_content")
  if (content) {
    setCookie("utm_content", content);
  }

  const term = params.get("utm_term")
  if (term) {
    setCookie("utm_term", term);
  }

  const gclid = params.get("gclid")
  if (gclid) {
    setCookie("gclid", gclid);
  }

  const fbclid = params.get("fbclid")
  if (fbclid) {
    setCookie("fbclid", fbclid);
  }

  let funnelName = mainFunnelName;
  let funnelVersion = mainFunnelVersion;
  if (location.pathname.startsWith('/go')) {
    funnelName = 'go';
    funnelVersion = '1';
  } else if (location.pathname.startsWith('/claude-2')) {
    funnelName = 'claude';
    funnelVersion = '2';
  } else if (location.pathname.startsWith('/claude')) {
    funnelName = 'claude';
    funnelVersion = '1';
  } else if (location.pathname.startsWith('/stt2')) {
    funnelName = 'stt';
    funnelVersion = '2';
  } else if (location.pathname.startsWith('/stt')) {
    funnelName = 'stt';
    funnelVersion = '1';
  } else if (location.pathname.startsWith('/life-reset')) {
    funnelName = 'life-reset';
    funnelVersion = '1';
  } else {
    funnelName = 'claude';
    funnelVersion = '2';
  }

  setCookie("funnel_name", funnelName);
  setCookie("funnel_version", funnelVersion);
  TagManager.dataLayer({
    dataLayer: {
      funnelName,
      funnelVersion,
    },
  });

  const gender = params.get("gender") || localStorage.getItem("gender");
  if (gender && !selectedGender) {
    setSelectedGender(gender);
    localStorage.setItem("gender", gender);
  }

  let userId = params.get("user_id");
  if (userId) {
    localStorage.setItem("userId", userId);
  }

  userId = localStorage.getItem("userId");
  const isCreateUserLoading = useRef(false);
  useEffect(() => {
    (async () => {
      if (userId === null && !isCreateUserLoading.current && location.pathname.startsWith('/articles/')) {
        isCreateUserLoading.current = true;
        const { data, status } = await createUser();
        if (status === 200) {
          localStorage.setItem('userId', data.id);
          TagManager.dataLayer({ dataLayer: { userId: data.id } });
        }
        isCreateUserLoading.current = false;
      }
    })();
  }, [userId, location.pathname]);

  return (
    <div className="App">
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/articles/paycheck-to-paycheck" element={<ArticlePaycheckToPaycheck />} />
        <Route path="/articles/i-tried-the-career-freedom-plan" element={<ArticleITriedTheCareerFreedomPlan />} />
        <Route path="/articles/ai-ran-my-marketing" element={<ArticleAIRanMyMarketing />} />
        <Route path="/articles/morning-routine" element={<ArticleMorningRoutine />} />

        <Route path="/terms" element={<ExternalRedirect to="https://app.trymotivo.com/terms" />} />
        <Route path="/privacy-policy" element={<ExternalRedirect to="https://app.trymotivo.com/privacy" />} />
        <Route path="/contact" element={<><Header /><div className='App__content'><ContactPage /></div><Footer /></>} />

        <Route path="/" element={<Lander />} />
        <Route path="/*" element={<RedirectHome />} />
      </Routes>
    </Suspense>
    </div>
  );

}

export default App;
